module.exports = __webpack_public_path__ + "img/toggle_down.961b9e51.png";